export default __webpack_public_path__ + "static/media/عکس پرسنلی.12a896c9.jpg";